import { Theme, useMediaQuery } from "@material-ui/core";
import Person from "@material-ui/icons/Person";
import { List } from "@react-admin/ra-rbac";
import { useEffect, useState } from "react";
import { Create, Datagrid, Edit, EmailField, ImageField, ImageInput, ListProps, minLength, PasswordInput, required, SelectInput, SimpleForm, SimpleList, TextField, TextInput, useAuthProvider, useGetIdentity, useRecordContext } from "react-admin";
import { AvatarField, ChipTranslateField, CustomTitle, doChoices, Legend, Loader, Row } from "../common/components";
import { role } from "../common/components/utils/choice";


export const UserIcon = Person;

export const UserList = (props: ListProps) => {
    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
    return (
        <List {...props} filters={[
            <TextInput source="fullname" alwaysOn />,
            <SelectInput source="role" choices={role} alwaysOn />
        ]}>
            {isSmall
                ? <SimpleList className="noopacity"
                    leftIcon={record => <AvatarField record={record} />}
                    primaryText={record => record.fullname}
                    secondaryText={record => record.email}
                    tertiaryText={record => <ChipTranslateField source="role" record={record} />}
                />
                : <Datagrid rowClick="edit">
                    <AvatarField />
                    <TextField source="firstname" />
                    <TextField source="lastname" />
                    <EmailField source="email" />
                    <ChipTranslateField source="role" />
                </Datagrid>}
        </List>
    );
};

const UserForm = ({ isSettings = false, ...props }) => {
    const record = useRecordContext();
    const [allowEdit, setAllowEdit] = useState(record?.id === undefined);
    const authProvider = useAuthProvider();
    const roleEditable = authProvider.getRoleEditable();
    useEffect(() => {
        if (record.id) {
            setAllowEdit(roleEditable.indexOf(record.role) !== -1);
        }
    }, [record, roleEditable]);
    const allowEditOrMyself = isSettings || allowEdit;
    return <SimpleForm {...props} redirect="@list">
        <Legend label="resources.user.identity" />
        <Row>
            <TextInput disabled={!allowEditOrMyself} source="firstname" validate={required()} />
            <TextInput disabled={!allowEditOrMyself} source="lastname" validate={required()} />
        </Row>
        <TextInput disabled={!allowEditOrMyself} source="email" type="email" validate={required()} />
        {allowEditOrMyself && <PasswordInput fullWidth source="newPassword" validate={minLength(20)} />}
        <SelectInput disabled={!allowEdit} source="role" choices={allowEdit ? doChoices.call("role", roleEditable) : role} validate={[required()]} />
        <ImageField source="avatar" />
        {allowEditOrMyself && <ImageInput source="newAvatar" accept="image/*" maxSize={110000}>
            <ImageField source="src" title="title" />
        </ImageInput>}
    </SimpleForm>
}

export const UserPreference = () => {
    const { identity } = useGetIdentity();
    if (!identity || !identity.id) return <Loader />;
    return <UserEdit basePath="user" resource="user" id={identity.id} isSettings />;
}


export const UserEdit = ({ isSettings = false, ...props }) =>
    <Edit {...props} title={<CustomTitle title="user" value={({ fullname }) => fullname} />} >
        <UserForm isSettings={isSettings} />
    </Edit>;

export const UserCreate = props =>
    <Create {...props} >
        <UserForm />
    </Create>;